import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  footer: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: '14px 32px',
    borderTop: `1px solid ${theme.palette.divider}`,
    background: 'transparent',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px',
      justifyContent: 'center',
      textAlign: 'center'
    }
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 4
  },
  link: {
    padding: '4px 10px',
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.text.disabled,
    borderRadius: 8,
    whiteSpace: 'nowrap',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light
    }
  },
  text: {
    fontSize: 13,
    color: theme.palette.text.disabled
  }
}))

export default useStyles
